export const previewCardWidth = 320
export const previewCardHeight = 192

export const postResetTimeOffsetInSeconds = 0

export const autoplayNextResetDelayInSeconds = 10

export const maxAutoPlayedResetsCount = 10
